import React, {Component} from 'react';
import { withStyles} from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1300,
        color: '#fff'
    }
});

export default withStyles(styles)((props) => {
    const {
        classes,
        toggleLoading,
        toggleLoadingHandler
    } = props;

    return (
        <Backdrop className={classes.backdrop} open={toggleLoading}
                  onClick={()=>{toggleLoadingHandler(false)}}>
            <CircularProgress color="inherit" />
        </Backdrop>
    )
});